import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=38c9c756&scoped=true"
import script from "./secondStep.vue?vue&type=script&lang=js"
export * from "./secondStep.vue?vue&type=script&lang=js"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=38c9c756&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9c756",
  null
  
)

export default component.exports